import { resetPassword, setResetPasswordStatus } from "actions/user";
import SageButton from "kit/SageButton";
import SageErrorAlert from "kit/SageErrorAlert";
import SageScreen from "kit/SageScreen";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import resetPasswordStatusSelector from "selectors/resetPasswordStatus";
import resetPasswordEmailCodeSelector from "./resetPasswordEmailCode";

const ResetPassword: React.FC = () => {
    const status = useSelector(resetPasswordStatusSelector);
    const dispatch = useDispatch();
    const resetPasswordData = useSelector(resetPasswordEmailCodeSelector);
    const [password, setPassword] = React.useState("");
    const onSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            dispatch(
                resetPassword(
                    password,
                    resetPasswordData?.code || "",
                    resetPasswordData?.email || ""
                )
            );
        },
        [dispatch, resetPasswordData, password]
    );

    const onPasswordChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setPassword(e.target.value);
        },
        [setPassword]
    );

    React.useEffect(() => {
        dispatch(setResetPasswordStatus("none"));
    }, [dispatch]);

    const onDismissError = React.useCallback(() => {
        dispatch(setResetPasswordStatus("none"));
    }, [dispatch]);

    return (
        <SageScreen>
            <h1>Create New Password</h1>
            <p>Enter your new password here.</p>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label htmlFor="passwordInput">New Password</label>
                    <input
                        value={password}
                        onChange={onPasswordChange}
                        disabled={status === "loading"}
                        type="password"
                        autoComplete="new-password"
                        className="form-control"
                        id="passwordInput"
                    />
                </div>
                {status !== "success" && (
                    <SageButton text="Change Password" type="submit" />
                )}
                {status === "success" && (
                    <Link to="/welcome/login">
                        Password Changed, Login Again
                    </Link>
                )}
                {status === "error" && (
                    <SageErrorAlert
                        onDismiss={onDismissError}
                        text={"There was an error. Please try again."}
                    />
                )}
            </form>
        </SageScreen>
    );
};

export default ResetPassword;
